import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/Buttons";

const ErrorPage = ({ error, resetErrorBoundary }) => {
  const navigate = useNavigate();

  return (
    <div className="h-screen p-3">
      <div className="flex flex-col items-center h-full justify-center bg-gray-100 text-center rounded-3xl">
        <h1 className="text-4xl font-bold text-red-600">Something went wrong</h1>
        <p className="text-lg text-gray-700 mt-4">
          We're sorry, but something went wrong. Please try again later.
        </p>
        <Button
          type="primary"
          className="mt-6"
          onClick={() => navigate("/dashboard")} // Redirect to the dashboard page
        >
          Go to Homepage
        </Button>
      </div>

    </div>
  );
};

export default ErrorPage;